import { EntityType } from '../types';
import { wordToNoun } from '../utils';
import type { GameEngine } from './GameEngine';
import type { Entity } from './Entity';

export class RuleParser {
  private game: GameEngine;

  constructor(game: GameEngine) {
    this.game = game;
  }

  public parseRules(): void {
    this.game.rules = [];

    for (let dim = 2; dim <= 4; dim++) {
      this.game.dimensionData[dim].wordBoxes.forEach((w: any) => {
        w.partOfActiveRule = false;
        w.updateGraphics();
      });
    }

    for (let dim = 2; dim <= 4; dim++) {
      const connectedWords = this.game.dimensionData[dim].connectedWords;

      for (let i = 0; i <= connectedWords.length - 3; i++) {
        const w1 = connectedWords[i];
        const w2 = connectedWords[i + 1];
        const w3 = connectedWords[i + 2];

        if (w2.type === 'WORD_IS') {
          const noun = wordToNoun(w1.type);
          const property = wordToNoun(w3.type);

          if (EntityType[noun as keyof typeof EntityType]) {
            this.game.rules.push({ noun, property, dimension: dim });

            w1.partOfActiveRule = true;
            w2.partOfActiveRule = true;
            w3.partOfActiveRule = true;

            w1.updateGraphics();
            w2.updateGraphics();
            w3.updateGraphics();
          }
        }
      }
    }
  }

  public hasProperty(entity: Entity, property: string): boolean {
    if (!entity) return false;

    for (const rule of this.game.rules) {
      if (rule.noun === entity.type && rule.property === property) {
        return true;
      }
    }
    return false;
  }
}
